import { useState } from 'react'
import * as actions from '@actions'
import { CHECK_FIELDS } from '@constants'
import { toast } from 'react-toastify'
import cn from 'clsx'

import CheckRow from './CheckRow'
import Checkbox from '$components/Forms/Checkbox'
import ConfirmationModal from '@components/shared/ConfirmationModal'
import { MdInfoOutline, MdDeleteSweep } from 'react-icons/md'
import { BsArrowDownUp, BsSortDown, BsSortUp } from 'react-icons/bs'

const ChecksTable = ({
    className,
    checks,
    checked,
    allChecked,
    someChecked,
    hasChecked,
    toggleChecked,
    toggleAllChecked,
    orderField,
    orderDirection,
    onHeaderClick,
    unmappedChecks,
    setMapCheckId,
}) => {
    
    const [statusInfoModalOpen, setStatusInfoModalOpen] = useState(false)
    const [deleteChecksModalOpen, setDeleteChecksModalOpen] = useState(false)
    
    const deleteSelectedChecks = async () => {
        
        try {
            
            await Promise.all(Object.keys(checked).map(it => actions.deleteCheck(checks[it].id)))
            await actions.fetchChecks()
            
            toast.success('Checks deleted')
            
        } catch (e) {
            
            console.error('deleteSelectedChecks', e)
            
            toast.error('Failed to delete checks')
            
        }
        
    }
    
    if (!checks?.length) return (
        <div className="p-8 text-center">
            <i>No checks found</i>
        </div>
    )
    
    return (<>
        
        <div className="w-full overflow-x-auto">
            <table className={cn('ChecksTable table-pin-rows', className)}>
                <thead>
                    <tr>
                        <th>
                            <Checkbox
                                checked={allChecked}
                                indeterminate={someChecked}
                                onChange={toggleAllChecked} />
                        </th>
                        <th>Name</th>
                        {/* <th>Organizations</th> */}
                        {Object.keys(CHECK_FIELDS).map(it => (
                            CHECK_FIELDS[it].sortable ?
                                <th
                                    key={it}
                                    className="cursor-pointer"
                                    onClick={() => onHeaderClick(CHECK_FIELDS[it].key)}>
                                    <div className="flex">
                                        <span>{it}</span>
                                        <span className="text-md pt-2">
                                            {orderField !== CHECK_FIELDS[it].key && <BsArrowDownUp />}
                                            {orderField === CHECK_FIELDS[it].key && (
                                                orderDirection === 'DESC' ? <BsSortDown /> : <BsSortUp />
                                            )}
                                        </span>
                                    </div>
                                </th> :
                                <th key={it}>{it}</th>
                        ))}
                        <th>
                            <div className="flex items-center content-center gap-2">
                                <span>Status</span>
                                <button
                                    className="btn btn-sm btn-square"
                                    onClick={() => setStatusInfoModalOpen(true)}>
                                    <MdInfoOutline className="text-lg" />
                                </button>
                            </div>
                        </th>
                        <th>
                            {(allChecked || someChecked) && (
                                <div className="flex items-center content-center justify-end">
                                    <button
                                        className="btn btn-sm btn-square"
                                        onClick={() => setDeleteChecksModalOpen(true)}>
                                        <MdDeleteSweep className="text-2xl text-red-300" />
                                    </button>
                                </div>
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {checks?.map(it => (
                        <CheckRow
                            key={it?.id}
                            CHECK_FIELDS={CHECK_FIELDS}
                            check={it}
                            showMeta={true}
                            hasChecked={hasChecked}
                            toggleChecked={toggleChecked}
                            unmappedChecks={unmappedChecks}
                            setMapCheckId={setMapCheckId} />
                    ))}
                </tbody>
            </table>
        </div>
        
        <ConfirmationModal
            showModal={statusInfoModalOpen}
            showHideModal={setStatusInfoModalOpen}
            title="Check Processing Status"
            message={(<>
                <p>
                    When a check is uploaded, it will be processed into pages,
                    and relevant information extracted.
                </p>
                <p className="mt-4">
                    This process is usually fast, but until it&apos;s complete,
                    checks cannot be viewed or modified.
                </p>
            </>)} />
        
        <ConfirmationModal
            showModal={deleteChecksModalOpen}
            showHideModal={setDeleteChecksModalOpen}
            title="Delete Checks"
            onConfirm={deleteSelectedChecks}
            message={<p>Are you sure you want to delete these checks?</p>} />
    
    </>)
    
}

export default ChecksTable
